// @ts-strict-ignore
import React from 'react';
import cloneDeep from 'lodash/cloneDeep';

import { snakeToCaps } from '~/helpers/formatting';


interface CustomFieldsProps {
  customer_id?: number;
  customFields: { [key: string]: any };
}

const CustomFields: React.FC<CustomFieldsProps> = ({ customer_id: customerId, customFields }) => {
  const customFieldsKeys = Object.keys(customFields);

  const filterMetaIncomeForGemini = key => {
    const cpy = cloneDeep(customFields[key]);
    // FIXME: delete this when Gemini is done testing, long term this should filter out
    //        the same things filtered metadata does
    if (customerId !== 8159) {
      return cpy;
    }
    if (key === 'meta') {
      if (cpy.income) {
        cpy.income = '[redacted]';
      }
    }
    return cpy;
  };


  return (
    <div className="custom-field-wrapper">
      {customFieldsKeys.map(key => (
        <div key={key} className="row small-header">
          <div className="col"><strong>{snakeToCaps(key)}</strong></div>
          <div className="col-8 custom-field-value">
            {JSON.stringify(filterMetaIncomeForGemini(key))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default CustomFields;
